import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    editWedgeplay,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(this.props.data.seldate), 
            student:this.props.data.student, 
            eid:this.props.data.eid, 
            carryform: this.props.data.carryform,
            cntcry:this.props.data.cntcry,
            clubform: this.props.data.clubform,
            cntclub:this.props.data.cntclub,
            ballform: this.props.data.ballform,
            cntball:this.props.data.cntball,
            rateform: this.props.data.rateform,
            cntrate: this.props.data.cntrate,
            loftform: this.props.data.loftform,
            cntloft: this.props.data.cntloft,
            dynamicform: this.props.data.dynamicform,
            cntdynamic:this.props.data.cntdynamic,
            launchform: this.props.data.launchform,
            cntlaunch:this.props.data.cntlaunch,
            landingform:this.props.data.landingform,
            cntlanding:this.props.data.cntlanding,  
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    editHandleSubmit(event){
        event.preventDefault();
        var eid=this.state.eid;
        let cntcry=this.state.cntcry;
        let cntclub=this.state.cntclub;
        let cntball=this.state.cntball;
        let cntrate=this.state.cntrate;
        let cntloft=this.state.cntloft;
        let cntdynamic=this.state.cntdynamic;
        let cntlaunch=this.state.cntlaunch;
        let cntlanding=this.state.cntlanding;
        
        this.props.editWedgeplay(event, eid, cntcry, cntclub, cntball, cntrate, cntloft, cntdynamic, cntlaunch, cntlanding);
        setTimeout(() => {
            this.props.onClick();
        }, 2000);     
    }  

    addFormFields(fmval) {
        if(fmval==1){
            var chktotal=this.state.cntcry;
            var totalsep=chktotal+1;
            this.setState(({
                cntcry:totalsep,  
                carryform: [...this.state.carryform, {  carry : "" }]
            }))
        }else if(fmval==2){
            var chktotal=this.state.cntclub;
            var totalsep=chktotal+1;
            this.setState(({
                cntclub:totalsep,  
                clubform: [...this.state.clubform, {  club : "" }]
            }))
        }else if(fmval==3){
            var chktotal=this.state.cntball;
            var totalsep=chktotal+1;
            this.setState(({
                cntball:totalsep,  
                ballform: [...this.state.ballform, {  ball : "" }]
            }))
        }else if(fmval==4){
            var chktotal=this.state.cntrate;
            var totalsep=chktotal+1;
            this.setState(({
                cntrate:totalsep,  
                rateform: [...this.state.rateform, {  rate : "" }]
            }))
        }else if(fmval==5){
            var chktotal=this.state.cntloft;
            var totalsep=chktotal+1;
            this.setState(({
                cntloft:totalsep,  
                loftform: [...this.state.loftform, {  loft : "" }]
            }))
        }else if(fmval==6){
            var chktotal=this.state.cntdynamic;
            var totalsep=chktotal+1;
            this.setState(({
                cntdynamic:totalsep,  
                dynamicform: [...this.state.dynamicform, {  dynamic : "" }]
            }))
        }else if(fmval==7){
            var chktotal=this.state.cntlaunch;
            var totalsep=chktotal+1;
            this.setState(({
                cntlaunch:totalsep,  
                launchform: [...this.state.launchform, {  launch : "" }]
            }))
        }else if(fmval==8){
            var chktotal=this.state.cntlanding;
            var totalsep=chktotal+1;
            this.setState(({
                cntlanding:totalsep,  
                landingform: [...this.state.landingform, {  landing : "" }]
            }))
        }
    }

    removeFormFields(i,fmval){
        if(fmval==1){
            let carryform = this.state.carryform;
            var chktotal=this.state.cntcry;
            var totalsep=chktotal-1;
            carryform.splice(i, 1);
            this.setState({ carryform, cntcry:totalsep });
        }else  if(fmval==2){
            let clubform = this.state.clubform;
            var chktotal=this.state.cntclub;
            var totalsep=chktotal-1;
            clubform.splice(i, 1);
            this.setState({ clubform, cntclub:totalsep });
        }else  if(fmval==3){
            let ballform = this.state.ballform;
            var chktotal=this.state.cntball;
            var totalsep=chktotal-1;
            ballform.splice(i, 1);
            this.setState({ ballform, cntball:totalsep });
        }else  if(fmval==4){
            let rateform = this.state.rateform;
            var chktotal=this.state.cntrate;
            var totalsep=chktotal-1;
            rateform.splice(i, 1);
            this.setState({ rateform, cntrate:totalsep });
        }else  if(fmval==5){
            let loftform = this.state.loftform;
            var chktotal=this.state.cntloft;
            var totalsep=chktotal-1;
            loftform.splice(i, 1);
            this.setState({ loftform, cntloft:totalsep });
        }else  if(fmval==6){
            let dynamicform = this.state.dynamicform;
            var chktotal=this.state.cntdynamic;
            var totalsep=chktotal-1;
            dynamicform.splice(i, 1);
            this.setState({ dynamicform, cntdynamic:totalsep });
        }else  if(fmval==7){
            let launchform = this.state.launchform;
            var chktotal=this.state.cntlaunch;
            var totalsep=chktotal-1;
            launchform.splice(i, 1);
            this.setState({ launchform, cntlaunch:totalsep });
        }else  if(fmval==8){
            let landingform = this.state.landingform;
            var chktotal=this.state.cntlanding;
            var totalsep=chktotal-1;
            landingform.splice(i, 1);
            this.setState({ landingform, cntlanding:totalsep });
        }  
      
    }

    handleChange(i, e, fmval) {
        const re = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]*$/;
        if(fmval==1){
            let carryform = this.state.carryform;       
            carryform[i][e.target.name] = e.target.value;
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ carryform });
            }
        }else if(fmval==2){
            let clubform = this.state.clubform;       
            clubform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ clubform });
            }
        }else if(fmval==3){
            let ballform = this.state.ballform;       
            ballform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ ballform });
            }
        }else if(fmval==4){
            let rateform = this.state.rateform;       
            rateform[i][e.target.name] = e.target.value;  
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ rateform });
            }
        }else if(fmval==5){
            let loftform = this.state.loftform;       
            loftform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ loftform });
            }
        }else if(fmval==6){
            let dynamicform = this.state.dynamicform;       
            dynamicform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ dynamicform });
            }
        }else if(fmval==7){
            let launchform = this.state.launchform;       
            launchform[i][e.target.name] = e.target.value;
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ launchform });
            }
        }else if(fmval==8){
            let landingform = this.state.landingform;       
            landingform[i][e.target.name] = e.target.value;
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ landingform });
            }
        }        
    }


render() {

    const { studentlists, particulartqwedgeplay, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

    const styles = {
        adbtn: {
            cursor: "pointer",
            color:"#7070f0",
            marginRight: "40px"
        },
        rembtn:{
            position:"relative",
            float: "right",
            marginTop: "-25px",
            marginRight: "20px",
            cursor: "pointer"
        }
    };

      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Edit Wedge Play">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-md-7"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                        </div> 
                                        
                                        <div className="col-sm-12 col-md-6">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="country">CLUB</Label>
                                                <select name="selclub" id="selclub" className= "form-control form-control-alternative" defaultValue={particulartqwedgeplay.gwp_selclub} required>
                                                <option value=""> </option> 
                                                <option value="60*">60*</option>
                                                <option value="58*">58*</option>
                                                <option value="56*">56*</option>
                                                <option value="54*">54*</option>
                                                <option value="52*">52*</option>
                                                <option value="50*">50*</option>              
                                                <option value="P.W">P.W</option>
                                             </select>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-6"> 
                                        <Label for="country">CARRY (yds) <span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(1)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                        {this.state.carryform.map((element, index) => (  
                                            <FormGroup> 
                                                <div className='col-md-11'>                                             
                                                <input type="text" name="carry" id={"carry_"+index} value={element.carry || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 1)}/>
                                                </div>
                                                {
                                                    index ? 
                                                    <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,1)}  > <i className="ti-close"></i></span>
                                                        : null
                                                }                                                
                                            </FormGroup>  
                                        ))}    
                                        </div> 
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">CLUB SPEED (mph)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(2)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.clubform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="club" id={"clubspeed_"+index} value={element.club || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 2)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,2)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">BALL SPEED (mph)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(3)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.ballform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="ball" id={"ballspeed_"+index} value={element.ball || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 3)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,3)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">SPIN RATE (rpm)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(4)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.rateform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="rate" id={"spinrate_"+index} value={element.rate || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 4)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,4)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>  
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">SPIN LOFT (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(5)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.loftform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="loft" id={"spinloft_"+index} value={element.loft || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 5)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,5)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div> 
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">DYNAMIC LOFT (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(6)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.dynamicform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="dynamic" id={"dynamicloft_"+index} value={element.dynamic || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 6)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,6)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div> 
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">LAUNCH ANGLE (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(7)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.launchform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="launch" id={"launchangle_"+index} value={element.launch || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 7)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,7)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div> 
                                        <div className="col-sm-12 col-md-6"> 
                                            <Label for="country">LANDING ANGLE (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(8)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.landingform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="landing" id={"landingangle_"+index} value={element.landing || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 8)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,8)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>   
                                        <div className="col-sm-12 col-md-12">   
                                            <FormGroup>
                                                <Label for="country">Notes</Label>
                                                <textarea rows="2" type="text" name="notes" id="notes" className="form-control form-control-alternative" defaultValue={particulartqwedgeplay.gwp_notes}></textarea>
                                            </FormGroup>  
                                        </div>                 

                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, tqwedgeplay}) => {
    const { studentlists, loading } = mostlyused;
    const { particulartqwedgeplay } = tqwedgeplay;
    return { studentlists, particulartqwedgeplay, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    editWedgeplay,
})(EditItems);
